import { useSearchParams } from 'react-router-dom';
import CreateLandingPage from './CreateLandingPage';
import CreateFromIdeaPage from './CreateFromIdeaPage';
import CreateFromBlogPage from './CreateFromBlogPage';
import CreateFromVideoPage from './CreateFromVideoPage';
import HelpMeWithIdeasPage from './HelpMeWithIdeasPage';

/**
 * Router component that renders the correct create page based on ?type= query param
 *
 * Supported types:
 * - (none): Landing page with all create options
 * - idea: Simple text idea → AI generation
 * - blog: Blog URL/text → AI generation
 * - video: Video upload → transcription → clips → AI generation
 * - brainstorm: AI-generated content ideas
 */
export default function CreatePageRouter() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  switch (type) {
    case 'idea':
      return <CreateFromIdeaPage />;
    case 'blog':
      return <CreateFromBlogPage />;
    case 'video':
      return <CreateFromVideoPage />;
    case 'brainstorm':
      return <HelpMeWithIdeasPage />;
    default:
      // No type specified, show landing page with all options
      return <CreateLandingPage />;
  }
}
